import { createSelector } from 'reselect';

const getRange = (state, props) => {
  const { category } = props.match.params;
  switch (category) {
    case 'skin-body-care':
      return state.rangeSkinBodyCare;
    case 'hair-care':
      return state.rangeHairCare;
    case 'hair-color':
      return state.rangeHairColor;
    case 'make-up':
      return state.rangeMakeUp;
    case 'mens':
      return state.rangeMens;
    case 'perm':
      return state.rangePerm;
    case 'styling':
      return state.rangeStyling;
    default:
      return null;
  }
};
const getSlug = (state, props) => props.match.params.rangename;
const getRangesObj = state => ({
  productRangeSkinBodyCare: state.rangeSkinBodyCare,
  productRangeHairCare: state.rangeHairCare,
  productRangeHairColor: state.rangeHairColor,
  productRangeMakeUp: state.rangeMakeUp,
  productRangeMens: state.rangeMens,
  productRangePerm: state.rangePerm,
  productRangeStyling: state.rangeStyling,
});

/* eslint-disable */
export const getRanges = createSelector([getRange, getSlug], (range, slug) => range[slug]);

export const getAllRangesByType = createSelector([getRangesObj], ranges => ranges );



// WEBPACK FOOTER //
// ./src/redux/selectors/productRange.js